import { get } from "lodash";

export default function triggerCustomGaEvent(eventName, eventBody) {
	let gaEvent = new CustomEvent(eventName, { detail: eventBody })
	dispatchEvent(gaEvent)

	let dataLayer = window.dataLayer || [];
	const hasEcommerceKey = get(eventBody, 'ecommerce', false);

	if (hasEcommerceKey) {
		dataLayer.push({
			event: eventName,
			...eventBody
		});

		return;
	}

	if (!hasEcommerceKey) {
		dataLayer.push({
			event: eventName,
			eventBody
		})
	}

}



// WEBPACK FOOTER //
// ./src/utilities/analytics/triggerCustomGaEvent.js